export default {
    "ASSET-2024-12-NEU26-01": {
        Title: "Secondary Cash Pool",
        Issuer: "neuprop 040 - 26 GmbH & Co. KG",
        Assetclass: "Private Equity",
        Volume: "990000",
        Email: "neuprop040-26@finexity.com",
        CreatedDate: "2024-12-10",
    },
    "ASSET-2024-11-FRD-02": {
        Title: "Ocean View!",
        Issuer: "FRD Andalucia 1 GmbH u. Co. KG",
        Assetclass: "Hospitality",
        Volume: "3078000",
        Email: "frd-andalucia-1@finexity.com",
        CreatedDate: "2024-11-30",
    },
    "ASSET-2024-11-TO-01": {
        Title: "Isar Valley! München",
        Issuer: "To-Co. GmbH",
        Assetclass: "Residential",
        Volume: "901000",
        Email: "to-co@finexity.com",
        CreatedDate: "2024-11-12",
    },
    "ASSET-2024-10-AREL-02": {
        Title: "Am Sportplatz! Bielefeld",
        Issuer: "AREL Baubetreuung GmbH",
        Assetclass: "Residential",
        Volume: "727000",
        Email: "arel-baubetreuung@finexity.com",
        CreatedDate: "2024-10-23",
    },
    "ASSET-2024-10-AREL10-01": {
        Title: "AREL10!",
        Issuer: "AREL Baubetreuung GmbH",
        Assetclass: "Residential",
        Volume: "812000",
        Email: "arel-baubetreuung@finexity.com",
        CreatedDate: "2024-10-04",
    },
    "ASSET-2024-09-LOUIS-01": {
        Title: "Louis Yachting SAY 42!",
        Issuer: "Louis Yachting GmbH",
        Assetclass: "Transportation",
        Volume: "470000",
        Email: "louis-yacht@finexity.com",
        CreatedDate: "2024-09-10",
    },
    "ASSET-2024-08-neuprop040-10-02": {
        Title: "Überseequartier Bridge",
        Issuer: "neuprop 040 - 10 GmbH & Co. KG",
        Assetclass: "Residential",
        Volume: "300000",
        Email: "neuprop040-10@finexity.com",
        CreatedDate: "2024-09-05",
    },
    "ASSET-2024-08-KALO-01": {
        Title: "Kalo Unity Sphere Nürnberg",
        Issuer: "Kalo Nürnberg GmbH",
        Assetclass: "Commercial",
        Volume: "2200000",
        Email: "kalo-nuernberg@finexity.com",
        CreatedDate: "2024-08-09",
    },
    "ASSET-2024-07-ASSETTA-03": {
        Title: "Solara One Mallorca",
        Issuer: "Solara One SPV S.L.U",
        Assetclass: "Hospitality",
        Volume: "1200000",
        Email: "solara-one@finexity.com",
        CreatedDate: "2024-06-19",
    },
    "ASSET-2024-05-FRD-01": {
        Title: "AndalusiaOne",
        Issuer: "FRD Andalucia 1 GmbH u. Co. KG",
        Assetclass: "Hospitality",
        Volume: "990000",
        Email: "frd-andalucia-1@finexity.com",
        CreatedDate: "2024-05-16",
    },
    "ASSET-2024-06-AB-01": {
        Title: "Brüder Amati Violine",
        Issuer: "neucollect - 03 GmbH & Co. KG",
        Assetclass: "Musical Instruments",
        Volume: "699000",
        Email: "neucollect-03@finexity.com",
        CreatedDate: "2024-06-21",
    },
    "ASSET-2024-12-TO-01": {
        Title: "Bavaria One",
        Issuer: "To&Co. GmbH",
        Assetclass: "Residential",
        Volume: "2010000",
        Email: "to-co@finexity.com",
        CreatedDate: "2024-02-04",
    },
    "ASSET-2024-12-FINCHAIN-01": {
        Title: "Finchain MedTech Scaling",
        Issuer: "Finchain Capital Partners AG",
        Assetclass: "Private Equity",
        Volume: "990000",
        Email: "finchain-capital@finexity.com",
        CreatedDate: "2024-12-13",
    },
    "ASSET-2024-12-RIO-01": {
        Title: "Ridge Climate Forest FOUR",
        Issuer: "Ridge Invest One GmbH",
        Assetclass: "Renewables",
        Volume: "500000",
        Email: "ridge-invest-one@finexity.com",
        CreatedDate: "2025-02-26",
    },
    "ASSET-2025-03-SACHWERT-08": {
        Title: "Wi IPP Solarportfolio 2.0",
        Issuer: "si-solar-1@finexity.com",
        Assetclass: "Renewables",
        Volume: "800000",
        Email: "kontakt@wi-ipp.de",
        CreatedDate: "2025-03-29",
    },
    "ASSET-2025-04-IREINVEST-01": {
        Title: "Verde Beach Santiago",
        Issuer: "ire.invest@finexity.com",
        Assetclass: "Hospitality",
        Volume: "6721000",
        Email: "ire.invest@finexity.com",
        CreatedDate: "2025-03-24",
    },
    "ASSET-2024-11-LIGHT-01": {
        Title: "Light Across",
        Issuer: "Light Across GmbH",
        Assetclass: "Private Equity",
        Volume: "5000000",
        Email: "light-across@finexity.com",
        CreatedDate: "2025-01-30",
    },
    "ASSET-2024-12-neuprop26-01": {
        Title: "Zweitmarkt-Portfolio",
        Issuer: "Neuprop 040 - 26 GmbH & Co. KG",
        Assetclass: "Private Equity",
        Volume: "1115000",
        Email: "neuprop040-26@finexity.com",
        CreatedDate: "2024-12-11",
    },
    "ASSET-2025-05-IREINVEST-02": {
        Title: "Verde Beach São Francisco ",
        Issuer: "Inter REAL Estate Invest GmbH",
        Assetclass: "Private Equity",
        Volume: "6900000",
        Email: "schriewer@andenbeteiligung.de",
        CreatedDate: "2025-05-20",
    },
    "ASSET-2025-05-NEUCOLLECT03-01": {
        Title: "Pressenda Violin",
        Issuer: "neucollect - 03 GmbH & Co. KG",
        Assetclass: "Musical Instruments",
        Volume: "859500",
        Email: "neucollect-03@finexity.com",
        CreatedDate: "2025-06-03",
    },
    "ASSET-2025-05-SINGULARITY-01": {
        Title: "Singularity AI Ventures",
        Issuer: "Singularity Ventures S.A.",
        Assetclass: "Private Equity",
        Volume: "1300000",
        Email: "singularity@finexity.com",
        CreatedDate: "2025-05-25",
    },
    "ASSET-2025-05-NEUART01-01": {
        Title: "Paul Schrader Masterpiece Collection",
        Issuer: "neuart - 01 GmbH & Co. KG",
        Assetclass: "Fine Art",
        Volume: "461000",
        Email: "neuart-01@finexity.com",
        CreatedDate: "2025-06-03",
    },
    "ASSET-2025-02-UNP-01": {
        Title: "Unplugged",
        Issuer: "GET UNPLUGGED LIMITED",
        Assetclass: "Private Equity",
        Volume: "435000",
        Email: "unplugged@finexity.com",
        CreatedDate: "2025-06-03",
    },
    "Asset-2025-03-VII-01": {
        Title: "Bad Lauterberg",
        Issuer: "neucare 040 - 1 GmbH",
        Assetclass: "Healthcare",
        Volume: "1970000",
        Email: "neucare040-1@finexity.com",
        CreatedDate: "2025-07-29",
    },
    "ASSET-2025-08-SIV3-01": {
        Title: "Birke! Wissen schafft Werte",
        Issuer: "SI Vermögen 3 GmbH",
        Assetclass: "Commercial",
        Volume: "2700000",
        Email: "si_vermoegen3@sachwertinvest.de",
        CreatedDate: "2025-07-29",
    },
    "ASSET-2025-08-neuprop28-01": {
        Title: "Al Barari",
        Issuer: "Neuprop 040 - 28 GmbH & Co. KG",
        Assetclass: "Residential",
        Volume: "1906000",
        Email: "neuprop040-28@finexity.com",
        CreatedDate: "2025-08-08",
    },
    "ASSET-2025-06-FRD-03": {
        Title: "Marbella Final Vista",
        Issuer: "FRD Andalucia 1 GmbH u. Co. KG",
        Assetclass: "Residential",
        Volume: "5650000",
        Email: "frd-andalucia-1@finexity.com",
        CreatedDate: "2025-08-13",
    },
    "ASSET-2025-05-AREL-03": {
        Title: "AREL 2 Extended Bond",
        Issuer: "AREL Baubetreuung GmbH",
        Assetclass: "Residential",
        Volume: "685000",
        Email: "arel-baubetreuung@finexity.com",
        CreatedDate: "2025-08-25",
    },
    "ASSET-2025-10-VOPI-01": {
        Title: "VOPI",
        Issuer: "PM7 Mobility GmbH",
        Assetclass: "Private Equity",
        Volume: "850000",
        Email: "vopi@finexity.com",
        CreatedDate: "2025-10-15",
    },
};
